

const data = {
    title: '5. Alternatieven',
    content: <>
        <p>In dit hoofdstuk zijn vier alternatieven opgesteld voor de opwek van elektriciteit door middel van windenergie en grootschalige zonne-energie. Het opgetelde bod (in TWh) van de RES-regio’s vormt hierbij de doelstelling op provinciaal niveau. De alternatieven laten zien hoe binnen de zoekgebieden op verschillende manieren invulling gegeven kan worden aan de doelstelling. In de laatste paragraaf beoordelen we de te verwachten energieopbrengsten en de milieueffecten van de alternatieven ten opzichte van de referentiesituatie en van elkaar.</p>
    </>,
    prev: '/energietransitie-05-05-2022/4/11',
    next: '/energietransitie-05-05-2022/5/1',
    
}

export default data